import React from 'react';
import styled from 'styled-components';

const handleColorType = (module, theme) => {
	switch (module) {
		case 'storage':
			return theme.storage;
		case 'account':
			return theme.account;
		case 'billing':
			return theme.billing;
		case 'support':
			return theme.support;
		case 'colocation':
			return theme.colocation;
		default:
			return theme.main;
	}
};

const HourlySVG = styled.svg`
	width: 14px;
	height: 20px;
`;

export const HourlySelector = props => {
	const { id, theme, module, position, className } = props;
	const rotate = position === 'left' ? 'rotate(90)' : 'rotate(270)';
	return (
		<HourlySVG id={id} module={module} width='8.582' height='8.579' viewBox='0 0 8.582 8.579'>
			<defs>
				<linearGradient
					id={`${id}-swipe-gradient`}
					x1='0.5'
					y1='1'
					x2='0.5'
					y2='-2'
					gradientTransform={rotate}
				>
					<stop offset='0' stop-color='white'>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
					<stop offset='0' stop-color={handleColorType(module, theme)}>
						<animate
							id={`${id}trans1`}
							dur='0.7s'
							attributeName='offset'
							fill='freeze'
							from='0'
							to='1'
							restart='always'
							begin='indefinite'
						/>
					</stop>
				</linearGradient>
			</defs>
			<path
				id='Time-Clock'
				d='M222.232 209.7a4.286 4.286 0 0 1 3.034 1.257l.017.019a4.288 4.288 0 0 1-.017 6.049l-.019.014a4.288 4.288 0 0 1-6.049-.017 4.291 4.291 0 0 1 0-6.068 4.275 4.275 0 0 1 3.032-1.257zm1.873 3.96h-1.542v-2.626a.33.33 0 0 0-.66 0v2.955a.328.328 0 0 0 .329.331h1.873a.33.33 0 1 0 0-.66zm.693-2.235a3.628 3.628 0 0 0-5.133 0 3.63 3.63 0 0 0 0 5.133 3.631 3.631 0 0 0 5.118.014l.014-.014a3.631 3.631 0 0 0 .017-5.121l-.017-.012z'
				className={className}
				transform='translate(-217.941 -209.695)'
			/>
		</HourlySVG>
	);
};
